<template>
	<div class="calendar-box-year calendar-bg-white">
		<div class="calendar-text-center" style="font-size: 1.4em;">
			<i class="fa fa-caret-left fa-lg" aria-hidden="true" style="padding-right: 11px;" v-on:click="setSelectYear(-1)"></i>
			{{ setYearOutput(selectingYear) }}
			<i class="fa fa-caret-right fa-lg" aria-hidden="true" style="padding-left: 11px;" v-on:click="setSelectYear(1)"></i>
		</div>
	</div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hrms-calendar-year',
  props: [ 'selectingYear', 'setSelectYear' ],
  methods: {
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    }
  }
}
</script>

<style lang="scss">
  .calendar-box-year {
    font-size: 1.2em;
    margin-top: 5px;
    cursor:pointer;
  }
</style>


// WEBPACK FOOTER //
// hrmsCalendarYear.vue?4e5c4606